import moment from "moment-timezone";

const currentYear = moment().year();
const currentMonth = moment().month();
const numberOfSeasons = (currentMonth < 3 ? currentYear - 1 : currentYear) - 2006;

export const config = {
    uiVersion: `${process.env.REACT_APP_UI_VERSION} (${process.env.REACT_APP_GIT_COMMIT_ID})`,
    apiURL: process.env.REACT_APP_API_URL,
    managerNames: ['Alex', 'Brian', 'Chuck', 'Karl', 'Matt', 'Mike', 'Sam', 'Seth'],
    seasonYears: Array(numberOfSeasons).fill().map((_, idx) => idx + 2007),
    salaryCap: 200,
    maxRosterSize: 16
};
